/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import styled from '../../styles/styled';
import { getFontStyles, getBorderStyles, getIcon, getSizing, getKindStyles, getTitleStyles, getMessageStyle, } from './helpers';
import Dismissible from './dismissible';
import { VARIANT } from '../constants';
const StyledMessage = styled.div `
  font: inherit;
  ${(props) => {
    const { dismissible, } = props;
    const style = getMessageStyle(dismissible);
    return {
        ...style,
    };
}}
`;
const StyledTitled = styled.div `
  margin-bottom: 4px;
  ${(props) => {
    const { theme, } = props;
    const style = getTitleStyles({ theme });
    return {
        ...style,
    };
}}
`;
const StyledIcon = styled.div `
margin-right: 14.5px;
`;
const Styled = styled.div `
  position: relative;
  margin: 0;
  border: none;
  text-decoration: none;
  overflow: hidden;
  background: none;
  display: flex;
 

  ${(props) => {
    const { theme, kind, variant, withIcon, dismissible, } = props;
    /**
     * * Other implementation would be get the styles as per attributes
     * * like getColor/getBorder/getTypography etc
     */
    const fonts = getFontStyles({ variant, kind, theme });
    const borders = getBorderStyles({ variant, kind, theme });
    const sizing = getSizing({
        variant, kind, theme,
    });
    const kindStyles = getKindStyles({
        theme, kind, variant, withIcon, dismissible,
    });
    // ! TODO: Huge refactor is under works
    /*
    const shapeStyles = getShapeStyles({ theme, shape }); */
    return {
        ...fonts,
        ...borders,
        ...sizing,
        ...kindStyles,
    };
}}

  button {
    padding: ${({ theme }) => `${theme.spacing.spacing60} ${theme.spacing.spacing10}`};
    background-color:unset;
  }

  // &:focus {
  //   outline: none;
  // }

  // &:disabled {
  //   cursor: default;
  // }
`;
const Component = (props) => {
    const { withIcon, kind, message, title, variant, children, } = props;
    return (React.createElement(Styled, Object.assign({}, props),
        (withIcon) && React.createElement(StyledIcon, null, getIcon(kind)),
        React.createElement(StyledMessage, Object.assign({}, props),
            ((variant === VARIANT.multi) && (title))
                && (React.createElement(StyledTitled, null, title)),
            message,
            ' ',
            React.createElement("div", null, (variant === VARIANT.multi && children) && children)),
        React.createElement(Dismissible, Object.assign({}, props))));
};
export default Component;
